<template>
  <div class="mpn_mypack page_title">
    <h2 class="service-title-c">
      {{ title }}
    </h2>
    <a
      href="javascript:history.go(-1)"
      class="back"
    ><i /></a>
  </div>
</template>

<script>
export default {
  name: 'MpnPageTitle',
  props: {
    title: {
      type: String,
      default: '타이틀',
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/plugins/mpn-base-components/MpnPageTitle.vue